import script from "./PosLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./PosLayout.vue?vue&type=script&setup=true&lang=ts"

import "./PosLayout.vue?vue&type=style&index=0&id=17ae9fda&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17ae9fda"]])

export default __exports__